import React from "react";

export default function ServiceSelectTag({
  ServiceNames,
  handleChange,
  value,
}) {
  console.log("ServiceNames", ServiceNames);
  return (
    <>
      <div className="col-md-6">
        <span className="text-input select-option">
          <select
            id="subject"
            name="serviceIntrested"
            value={value}
            onChange={handleChange}
          >
            <option value="select-subject">Service *</option>
            {ServiceNames.length > 0
              ? ServiceNames.map((item, index) => {
                  return (
                    <option value={item.name.replaceAll(" ", "")} key={index}>
                      {item.name}
                    </option>
                  );
                })
              : null}
          </select>
        </span>
      </div>
    </>
  );
}
